export default __webpack_public_path__ + "e850c8e9b7938519e740b77b61b2573e.png";